const fakeLocalStorage = (() => {
    // 1. Check if localStorage is available and functional
    try {
        const testKey = "__storage_test__";
        window.localStorage.setItem(testKey, testKey);
        window.localStorage.removeItem(testKey);
        return window.localStorage;
    } catch (e) {
        // 2. If it fails, return a simulated version
        const store = new Map();

        return {
            getItem: (key) => (store.has(key) ? store.get(key) : null),
            setItem: (key, value) => store.set(key, String(value)),
            removeItem: (key) => store.delete(key),
            clear: () => store.clear(),
            get length() {
                return store.size;
            },
            key: (index) => Array.from(store.keys())[index] || null,
        };
    }
})();

export default fakeLocalStorage;